import i18next from "i18next";
import { PrivilegeEnum } from "./RolesUtils";

export const DATA_HUB_SOURCE_TYPE = {
  RGE: "RGE",
  SBTI: "SBTI",
  DREAL_MARCHANDISES: "DREAL MARCHANDISES",
  DREAL_COMMISSIONNAIRES: "DREAL COMMISSIONNAIRES",
  DREAL_PERSONNES: "DREAL PERSONNES",
  LIST_TRAINING_ORGANISATIONS: "LISTE PUBLIQUE DES ORGANISMES DE FORMATION"
}

export const getDataHubSources = () => {
  return [
    {   
        subscription: "DATA_HUB_1",
        id: DATA_HUB_SOURCE_TYPE.RGE,
        sourceId: "1",
        index: 0,
        label: i18next.t(`thirdpartySheet.dataHub.sourceList.rge`),
        neededPrivilege: PrivilegeEnum.PRIVILEGE_VIEW_DATA_HUB_SOURCE
    },
    {   
        subscription: "DATA_HUB_2",
        id: DATA_HUB_SOURCE_TYPE.SBTI,
        sourceId: "2",
        index: 1,
        label: i18next.t(`thirdpartySheet.dataHub.sourceList.sbti`),
        neededPrivilege: PrivilegeEnum.PRIVILEGE_VIEW_DATA_HUB_SOURCE
    },
    {   
        subscription: "DATA_HUB_3",
        id: DATA_HUB_SOURCE_TYPE.DREAL_MARCHANDISES,
        sourceId: "3",
        index: 2,
        label: i18next.t(`thirdpartySheet.dataHub.sourceList.dreal_marchandises`),
        neededPrivilege: PrivilegeEnum.PRIVILEGE_VIEW_DATA_HUB_SOURCE
    },    
    {   
        subscription: "DATA_HUB_4",
        id: DATA_HUB_SOURCE_TYPE.DREAL_COMMISSIONNAIRES,
        sourceId: "4",
        index: 3,
        label: i18next.t(`thirdpartySheet.dataHub.sourceList.dreal_commissionnaires`),
        neededPrivilege: PrivilegeEnum.PRIVILEGE_VIEW_DATA_HUB_SOURCE
    },
    {   
        subscription: "DATA_HUB_5",
        id: DATA_HUB_SOURCE_TYPE.DREAL_PERSONNES,
        sourceId: "5",
        index: 4,
        label: i18next.t(`thirdpartySheet.dataHub.sourceList.dreal_personnes`),
        neededPrivilege: PrivilegeEnum.PRIVILEGE_VIEW_DATA_HUB_SOURCE
    },
    {   
        subscription: "DATA_HUB_6",
        id: DATA_HUB_SOURCE_TYPE.LIST_TRAINING_ORGANISATIONS,
        sourceId: "6",
        index: 5,
        label: i18next.t(`thirdpartySheet.dataHub.sourceList.list_training_organisations`),
        neededPrivilege: PrivilegeEnum.PRIVILEGE_VIEW_DATA_HUB_SOURCE
    }
  ]
}

export const getDrealLtiFields = (sourceId) => {
  const ltiFieldsMap = {
    [DATA_HUB_SOURCE_TYPE.DREAL_MARCHANDISES]: [
      'Numero_LTI',
      'Date_debut_validite_LTI',
      'Date_fin_validite_LTI',
      'Nombre_de_copies_LTI_valides',
    ],
    [DATA_HUB_SOURCE_TYPE.DREAL_PERSONNES]: [
      'Numero_LTI',
      'Date_de_debut_de_validite_LTI',
      'Date_de_fin_de_validite_LTI',
      'Nombre_de_copies_LTI_valides',
    ]
  };
  
  return ltiFieldsMap[sourceId] || [];
};

export const getDrealLcFields = (sourceId) => {
  const lcFieldsMap = {
    [DATA_HUB_SOURCE_TYPE.DREAL_MARCHANDISES]: [
      'Numero_LC',
      'Date_debut_validite_LC',
      'Date_fin_validite_LC',
      'Nombre_de_copies_LC_valides',
    ],
    [DATA_HUB_SOURCE_TYPE.DREAL_PERSONNES]: [
      'Numero_LC',
      'Date_de_debut_de_validite_LC',
      'Date_de_fin_de_validite_LC',
      'Nombre_de_copies_LC_valides',
    ]
  };
  
  return lcFieldsMap[sourceId] || [];
};